export const debounceOffset = 500;
let timeOffset = 0;

const nameRegex = /^[a-zA-ZżźćńółęąśŻŹĆĄŚĘŁÓŃ]*\s{1}[a-zA-ZżźćńółęąśŻŹĆĄŚĘŁÓŃ]+[-]?(\s?[a-zA-ZżźćńółęąśŻŹĆĄŚĘŁÓŃ]*)?$/;
const loginRegex = /^[a-zA-Z][a-zA-Z1-9]*$/;
const emailRegex = /^[a-zA-Z]{1}[a-zA-Z1-9\w]*@[a-zA-Z]{1,200}\.{1}[a-zA-Z]{1,55}$/;
const passwordRegex = /^(?=.*[a-zżąśćęńłó])(?=.*[A-ZŻĄŚĆĘŃŁÓ])(?=.*\d)[a-zA-Z\d].{5,}$/;


const minNameLength = 3;
const maxNameLength = 60;

const minLoginLength = 3;
const maxLoginLength = 35;

const minEmailLength = 5;
const maxEmailLength = 320;

const minPasswordLength = 8;
const maxPasswordLength = 25;

export function debounce(callback, timeout) {
  clearTimeout(timeOffset);
  timeOffset = setTimeout(callback, timeout);
}

export function validateName(e, paramName) {
  const { value } = e.target;
  const name = paramName;

  if (value.length <= 0) return;

  name.value = value;
  name.length = value.length;
  name.isValid = true;
  name.isTooShort = false;
  name.isTooLong = false;
  name.isAlphanumeric = true;

  if (name.length < minNameLength) name.isTooShort = true;
  else if (value.length > maxNameLength) name.isTooLong = true;

  if (!value.match(nameRegex)) name.isAlphanumeric = false;

  if (!name.isAlphanumeric || name.isTooLong || name.isTooShort) name.isValid = false;
}

export function validateLogin(e, paramLogin) {
  const { value } = e.target;
  const login = paramLogin;

  if (value.length <= 0) return;

  login.value = value;
  login.isValid = true;
  login.length = value.length;
  login.isTooShort = false;
  login.isTooLong = false;
  login.isAlphanumeric = true;
  // TODO: Check if the username is already taken
  login.alreadyTaken = false;

  if (login.length < minLoginLength) login.isTooShort = true;
  else if (value.length > maxLoginLength) login.isTooLong = true;

  if (!value.match(loginRegex)) login.isAlphanumeric = false;

  if (!login.isAlphanumeric || login.isTooLong || login.isTooShort || login.alreadyTaken) {
    login.isValid = false;
  }
}

export function validateEmail(e, paramEmail) {
  const { value } = e.target;
  const email = paramEmail;

  if (value.length <= 0) return;

  email.value = value;
  email.length = value.length;
  email.alreadyTaken = false;
  email.isTooShort = false;
  email.isTooLong = false;
  email.isAlphanumeric = true;
  email.isValid = true;

  if (email.length < minEmailLength) email.isTooShort = true;
  else if (value.length > maxEmailLength) email.isTooLong = true;

  if (!value.match(emailRegex)) email.isAlphanumeric = false;

  if (!email.isAlphanumeric || email.isTooLong || email.isTooShort || email.alreadyTaken) {
    email.isValid = false;
  }
}

export function validatePassword(e, paramPassword) {
  const { value } = e.target;
  const password = paramPassword;

  if (value.length <= 0) return;

  password.value = value;
  password.length = value.length;
  password.isTooShort = false;
  password.isTooLong = false;
  password.isAlphanumeric = true;
  password.isValid = true;

  if (password.length < minPasswordLength) password.isTooShort = true;
  else if (value.length > maxPasswordLength) password.isTooLong = true;

  if (!value.match(passwordRegex)) password.isAlphanumeric = false;

  if (!password.isAlphanumeric || password.isTooLong || password.isTooShort) {
    password.isValid = false;
  }
}

export function validateMatch(paramPassword, paramRepeatPassword) {
  const repeatPassword = paramRepeatPassword;
  const password = paramPassword;
  let isMatch = false;

  if (repeatPassword === password) isMatch = true;
  return isMatch;
}
